import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import sumBy from 'lodash/sumBy'
import { FormattedMessage } from 'react-intl'
import { Button, If, Text, Format } from '../..'
import { formatCurrency } from '../../../helpers/formatters'
import { ChangeTheseValues } from '../../../constants/trackingEvents'

const defaultProps = {
  long: false,
}

const propTypes = {
  long: PropTypes.bool,
  loans: PropTypes.array.isRequired,
  openLoans: PropTypes.func,
  loanRate: PropTypes.number,
  loanAmount: PropTypes.number,
  loanTerm: PropTypes.number,
  loanDate: PropTypes.string,
}

const YourLoanSentence = ({
  long,
  loans,
  openLoans,
  loanRate,
  loanAmount,
  loanTerm,
  loanDate,
}) => (
  <>
    <If condition={!long}>
      <FormattedMessage
        id='Homeowner.yourLoans.intro'
        defaultMessage='* Based on your'
      />
    </If>
    <If condition={long}>
      <FormattedMessage
        id='Homeowner.yourLoans.longIntro'
        defaultMessage='These calculations are all based on your'
      />
    </If>{' '}
    <If condition={loans.length === 1}>
      <FormattedMessage
        id='Homeowner.yourLoans.singleLoanDescription'
        defaultMessage='{loanTerm} year loan at {loanRate} for {loanAmount} from {loanDate}.'
        values={{
          loanTerm,
          loanRate: (
            <Text element='span' variant='success' nowrap>
              <Format.Rate value={loanRate} />
            </Text>
          ),
          loanAmount: (
            <Text element='span' variant='success' nowrap>
              <Format.Currency value={Math.round(loanAmount)} />
            </Text>
          ),
          loanDate: moment(loanDate).format('MMMM YYYY'),
        }}
      />
    </If>
    <If condition={loans.length > 1}>
      <FormattedMessage
        id='Homeowner.yourLoans.multiLoanDescription'
        defaultMessage='{numLoans} loans for {totalAmount}.'
        values={{
          numLoans: loans.length,
          totalAmount: formatCurrency(sumBy(loans, 'amount')),
        }}
      />
    </If>{' '}
    <Button minimal onClick={openLoans} track={ChangeTheseValues}>
      <FormattedMessage
        id='Homeowner.yourLoans.updateLoansButton'
        defaultMessage='Update these loan numbers'
      />
    </Button>
  </>
)

YourLoanSentence.propTypes = propTypes
YourLoanSentence.defaultProps = defaultProps

export default YourLoanSentence
